import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Tutorial, TutorialMaterial } from '../../models/tutorial.model';
import { FormArray, FormArrayName } from '@angular/forms';

@Component({
  selector: 'app-tutorial-item',
  templateUrl: './tutorial-item.component.html',
  styleUrls: ['./tutorial-item.component.scss', './../../tutorial.scss']
})
export class TutorialItemComponent implements OnInit {
  extension:string = '';
  @Input() isOrdering:boolean = false;
  @Input() isAdmin:boolean = false;
  @Input() disabled:boolean = false;
  @Input() index:number = null;
  @Input() type:string = null;
  @Input() item:Tutorial|TutorialMaterial = null;
  @Input() parentFormGroup: FormArray = null;
  @Output() selectItem =  new EventEmitter<void>();
  @Output() openModal =  new EventEmitter<boolean>();
  @Output() delete =  new EventEmitter<void>();
  @Output() changeShow =  new EventEmitter<boolean>();
  @Output() openItem =  new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
    if(this.item.file_link != null){
      this.extension = 'link';
    }
    else if(this.item.file_path != null){
      var fileExt = this.item.file_path.split('.').pop();
      var extList = ['ppt', 'txt', 'pdf', 'png', 'jpeg', 'jpg'];
      if(extList.includes(fileExt)){
        this.extension = fileExt;
      }
      else{
        this.extension = 'other';
      }
    }
  }
  onOpenItem(id:number){
    if(!this.isOrdering){
      this.openItem.emit(id);
    }
  }
  onOpenModal(id): void{
    this.openModal.emit(id);  

  }
  onSelectItem():void{
    this.selectItem.emit();  
  }
  onDelete(event):void{
    event.stopPropagation();
    this.delete.emit();  
  }
  onChangeShow(event): void{
    event.stopPropagation();
    this.changeShow.emit(this.disabled);  
  }
}
